/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_tps_explanation_dialog_text = () => `<strong>Max TPS (Max Recorded TPS)</strong> represents the highest number of transactions per second ever achieved by a blockchain.<br /><br />This metric can be calculated in two ways:<br /><br />1. <strong>Over 100 consecutive blocks:</strong> Calculated by dividing the total number of transactions in this period by the cumulative block duration in seconds (default view).<br />2. <strong>Per single block:</strong> Calculated using the block with the most transactions and the smallest block time.<br /><br />You can toggle between <strong>Max TPS (100 blocks)</strong> and <strong>Max TPS (1 block)</strong> using the switch:<img class='img-inside' src='https://res.cloudinary.com/dcruwhddg/image/upload/dialogs/max-recorded-tps-switch-3.png' alt='Max TPS switch' crossorigin='anonymous' />`
